import Vue from 'vue'
import {
  Dialog,
  Result,
  Button,
  Message,
  MessageBox,
  Icon,
  Link,
  Form,
  FormItem,
  Input,
  InputNumber,
  Switch,
  Radio,
  RadioGroup,
  RadioButton,
  Progress,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Loading,
  Divider,
  Descriptions,
  DescriptionsItem,
  Upload
} from 'element-ui'

Vue.use(Dialog)
Vue.use(Result)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Link)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Divider)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Upload)
Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
